import React from 'react';
import HomeIcon from './HomeIcon';
import HomeCollectionSeason from './HomeCollectionSeason';
import { COLLECTION_LINES, countPhrase, countLabel } from './HomeCollectionLines';
import s from './HomeCollection.module.css';

// The card a Collection-only person's Home is built around: both lines as doors and "Open Wall".
// (The approved prototype's peek of real models is not here yet — it waits on David's answer.)
export default function HomeCollectionWelcome({ collection, navigate }) {
  return (
    <article className={s.welcome} data-home-card="collection" data-home-group="portals" data-test="home-collection-welcome">
      {/* the head opens the Wall too (the same test hook the generic tile's body has: portal-collection) */}
      <button type="button" className={s.head} data-test="portal-collection" aria-label="Open Collection" onClick={() => navigate('collection')}>
        <span className={s.mark}><HomeIcon name="layers" /></span>
        <span className={s.headText}>
          <strong className={s.title}>Collection<HomeCollectionSeason season={collection?.season} /></strong>
          <span className={s.lede}>Every model of the season — its colours, shape and status, with pictures.</span>
        </span>
      </button>
      <div className={s.doors}>
        {COLLECTION_LINES.map(([key, label, icon]) => {
          const total = collection?.lines?.[key];
          return (
            <button type="button" key={key} className={s.door} data-test={`home-collection-${key}`} aria-label={countLabel(label, total)} onClick={() => navigate(`collection-${key}`)}>
              <span className={s.doorIcon}><HomeIcon name={icon} /></span>
              <span className={s.doorText}><strong>{label}</strong><span>{countPhrase(total)}</span></span>
              <span className={s.doorArrow}><HomeIcon name="arrow" /></span>
            </button>
          );
        })}
      </div>
      <div className={s.foot}>
        <HomeIcon name="eye" />
        <p>View only — models, colours, shapes, status and pictures</p>
        <button type="button" className={s.open} data-test="home-collection-open" onClick={() => navigate('collection-wall')}>Open Wall<span><HomeIcon name="arrow" /></span></button>
      </div>
    </article>
  );
}
